module.exports = __webpack_public_path__ + "static/media/dmiAbout.47ce3e08.png";